import Ajax from 'js/utils/ajax/ajax';
import { ApiCommunicationPreference } from 'js/scenes/Home/scenes/OrderDetails/scenes/EditServicePoint/interfaces';

export const extendPackagePickupDeadline = (checksum: string) =>
  Ajax.put(`/packages/v1/extend/pickup/deadline/${checksum}`);

export const resendPickupCode = (trackingReference: string, sendBy: ApiCommunicationPreference) =>
  Ajax.post(`/packages/v1/pickupCode/${trackingReference}`, sendBy);
